import Swiper from 'swiper/bundle'

function slideEvents() {
  const slider = document.querySelector('[data-target="slider-events"]')

  if (slider) {
    const slides = slider.querySelectorAll('.swiper-slide')
    const wrapper = slider.querySelector('.swiper-wrapper')
    const pagination = document.querySelector('[data-name="events-pagination"]')

    if (window.innerWidth < 768) {
      pagination.classList.remove('invisible')
      wrapper.classList.remove('gap-30')
      wrapper.classList.remove('flex')
      const slideEvents = new Swiper(slider, {
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 40,
        pagination: {
          el: '.swiper-pagination-events',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.swiper-button-next-events',
          prevEl: '.swiper-button-prev-events',
        },
      })
    } else {
      if (slides.length > 3) {
        pagination.classList.remove('invisible')
        wrapper.classList.remove('gap-30')
        wrapper.classList.remove('flex')
        const slideEvents = new Swiper(slider, {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 40,
          pagination: {
            el: '.swiper-pagination-events',
            type: 'fraction',
          },
          navigation: {
            nextEl: '.swiper-button-next-events',
            prevEl: '.swiper-button-prev-events',
          },
        })
      }
    }
  }
}

export default slideEvents
